import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="border-y border-line bg-navy-900 py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-74" data-mp="4vs0rz0u8fre">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-75" data-mp="9t1mb3l3w79y">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-2xl border border-line bg-navy-950 p-8 shadow-2xl shadow-black/40 sm:p-12" data-id="element-76" data-mp="etpngi31u4hw">
          <span className="inline-flex rounded-full bg-fiber/10 p-4 text-fiber" data-id="element-77" data-mp="slm9c4e4ji5u">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-78" data-mp="xjfi956taq9t" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-3xl font-bold tracking-tight text-white sm:text-4xl" data-id="element-79" data-mp="12kbjtc3oy0c2">
            7-Day <span className="text-gold" data-id="element-80" data-mp="17imwrvpa8qyi">Guarantee</span>
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-silver" data-id="element-81" data-mp="25sylow6dxoit">
            Study all 6 volumes and 5 bonuses this week. If the technical depth doesn&apos;t match your professional
            needs in telecommunications and fiber optic networks,{' '}
            <span className="font-semibold text-gold" data-id="element-82" data-mp="1vvkfrqi38i4r">we refund 100%. No questions. No complications.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}